import React, { useState } from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userMemberAccountList.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useAccountHook from 'src/webapp/hooks/account/account.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//comp
import EmptyData from 'src/webapp/views/component/data/EmptyData';
import PaymentCancelPopup from '../member/popup/PaymentCancel';//결제취소팝업

export default function List(props) {
    const { list, scrollRef } = props;//props
    //hooks
    const { stateFilter//예약상태필터
        , categoryFilter//카테고리필터
    } = useComnHook();
    const { isOpen, dataRef, onDismissHandler } = useAccountHook();
    //store
    const { admin } = useAdminStore();
    //리스트토글엘리먼트show&hide
    const [ toggle,setToggle ] = useState({});

    return (
        <>
        <Element tag={`div`} className={[styles.reservContainer, list?.length <= 0 ? "fullHeight" : null].join(" ")} propRef={el => (scrollRef.current = el)}>
            {list?.length > 0 ?
                <Element tag={`ul`}>
                    {list.length > 0 ? list.map((item, i) =>
                        <Element tag={`li`} key={item.ORDER_NO}>
                            <Element tag={`div`} className={styles.vehicleInfo}>
                                <Element tag={`div`} >
                                    <Element tag={`div`} style={{width: "8.125rem"}}><Element tag={`label`}>{item.PARTNER_NAME}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "5.125rem"}}><Element tag={`label`}>{item.MEMBER_NAME}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "11.94rem"}} className={styles.center}><Element tag={`span`}>방문일 {item.RESERV_DT}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "10.25rem"}} className={styles.center}><Element tag={`label`}>{item.BRAND_KOR_NAME + " " + item.MODEL_KOR_NAME}</Element></Element><hr/>
                                    <Element tag={`div`} style={{width: "4.25rem"}} className={styles.center}><Element tag={`label`}>{item.YEAR}년식</Element></Element><hr/>
                                    <Element tag={`div`} className={[styles.stretch, ("state" + item.STATE)].join(" ")}><Element tag={`label`}>{stateFilter(item.STATE)}</Element></Element>
                                    <a onClick={(e) => setToggle(toggle === item ? {} : item)}><FontAwesomeIcon icon={["fa-light", toggle === item ? "fa-chevron-up": "fa-chevron-down"].join(" ")} /></a>
                                </Element>
                            </Element>
                            {toggle === item ? 
                            <Element tag={`article`}>
                                <Element tag={`div`} className={styles.toggleContent}>
                                    <Element tag={`div`} style={{width: "8.625rem"}}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-scribble" />주행거리<Element tag={`strong`}>{item.KMLE}</Element>km</Element></Element><hr/>
                                    <Element tag={`div`}>
                                        <Element tag={`label`}>카테고리</Element>
                                        {item.ITEM_LIST.length > 0 ? 
                                            <Element tag={`div`}>
                                            {item.ITEM_LIST.length > 0 ? item.ITEM_LIST.map((children, i) =>
                                                <React.Fragment key={i}>
                                                {children.CATEGORY === (i > 0 ? item.ITEM_LIST[i - 1].CATEGORY : null) || i === 0 ? <span>[{categoryFilter(children.CATEGORY)}]</span> : null}
                                                <Element tag={`pre`}>{children.ITEM_NAME}</Element>
                                                </React.Fragment>
                                            ):null}
                                            </Element>
                                        : null}
                                    </Element><hr/>
                                    <Element tag={`div`} >
                                        <Element tag={`label`}>전달사항</Element>
                                        {item.CONTENT !== undefined ? <Element tag={`div`}><Element tag={`pre`}>{item.CONTENT}</Element></Element> : null}
                                    </Element><hr/>
                                    <Element tag={`div`} >
                                        <Element tag={`label`}>정비</Element>
                                        {item.RESULT !== undefined ? <Element tag={`div`}><Element tag={`label`}>정비내용</Element><Element tag={`pre`}>{item.RESULT}</Element></Element> : null}
                                        {item.REMARK !== undefined ? <Element tag={`div`}><Element tag={`label`}>특이사항</Element><Element tag={`pre`}>{item.REMARK}</Element></Element> : null}
                                    </Element>
                                </Element>
                                <Element tag={`div`}  className={styles.toggleContainer}>
                                    <Element tag={`ul`}>
                                        <Element tag={`li`}>
                                            <Element tag={`div`} style={{width: "5.125rem"}}><Element tag={`span`}>{item.PAY_METHOD}</Element></Element><hr/>
                                            <Element tag={`div`} style={{width: "11.94rem"}}><Element tag={`span`}>예약일 {item.REG_DT}</Element></Element><hr/>
                                            <Element tag={`div`} style={{width: "7.25rem"}}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-coins" />{item.AMOUNT}</Element></Element><hr/>
                                            <Element tag={`div`} className={styles.stretch}><Element tag={`span`}><FontAwesomeIcon icon="fa-light fa-coin" />{item.BALANCE_AMT}</Element></Element>
                                            <Element tag={`div`} className={styles.btnArea}>
                                                {admin.LEVEL <= 1 && item.STATE !== "6" && item.STATE !== "8" && item.CANCLE_YN === "Y" ? <Element anyprop={(e) => onDismissHandler('cancel', true, item)} tag={`button`}><Element tag={`span`}>결제취소</Element></Element> : null }
                                            </Element>
                                        </Element>
                                    </Element>
                                </Element>
                            </Element>
                            : null}
                        </Element>
                    ) : null}
                </Element>
            : <EmptyData />}
        </Element>
        {isOpen.cancel ? <PaymentCancelPopup isOpen={isOpen.cancel} data={dataRef} onDismiss={onDismissHandler} /> : null}
            </>
    );
}